export default [{
  path: "communityKanban",
  name: "communityKanban",
  component: () =>
    import ("@/views/communityKanban/communityKanban.vue"),
  meta: {
    title: "社区看板"
  }
}];